import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {marketRegister} from "../../services/marketRegister";
import {cartRegister} from "../../services/cartRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {BeatLoader} from "react-spinners";
import queryString from "query-string";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            lang: null,
            market: null,
            success: false,
            error: false,
            isLoading: false,
            markets: [],
            languages: [],
            trending: [],
            email: ""
        };
    };

    componentWillMount() {
        this._updateLang();
        this._updateLanguages();
        this._updateMarket();
        this._updateMarkets();
        this._updateTrending();
        this._updateDate();
    }

    _updateLang(){
        this.setState({lang: langRegister.lang()});
    }

    _updateLanguages(){
        this.setState({languages: JSON.parse(salesChannelRegister.get("languages"))});
    }

    _updateMarket(){
        this.setState({market: salesChannelRegister.get("market")});
    }

    _updateMarkets(){
        this.setState({markets: marketRegister.allMarkets()});
    }

    _updateTrending(){
        dataRegister.trendingIndustries(salesChannelRegister.get("market"), langRegister.lang()).then((response) => {
            if(!response.error){
                this.setState({trending: response});
            }
        }, (error) => {});
    }

    _updateDate(){
        let date = new Date();
        let year = date.getFullYear();
        this.setState({year: year});
    }

    _setLang(lang) {
        this.setState({lang: lang}, () => {
            langRegister.set(lang);
            this.props.props.history.replace("/" + salesChannelRegister.get("market") + "/" + langRegister.lang());
            window.location.reload();
        });
    }

    _setMarket(market){
        marketRegister.set(market);
        let default_lang = marketRegister.defaultLang();
        try{
            sessionStorage.clear();
        }catch (e) {}
        this.props.props.history.replace("/" + market + "/" + default_lang);
        window.location.reload();
    }

    _selectIndustry(prop){
        try {
            this.refs.searchIndustry.blur();
        } catch (e) {}
        let url_object = {industry: JSON.stringify(prop)};
        let query = queryString.stringify(url_object);
        if(dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1){
            window.open("https://app.devadbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop?" + query, '_blank');
        }else{
            window.open("https://app.adbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop?" + query, '_blank');
        }
    }

    _newsletter(){
        if(!this.state.isLoading){
            this.setState({error: false, success: false}, () => {
                if(this._emailValidation(this.state.email)){
                    this.setState({isLoading: true});
                    let data = {email: this.state.email, name: this.state.email, subject: "adbop newsletter request", message: salesChannelRegister.get('market')};
                    dataRegister.industryRequest(salesChannelRegister.get('market'), data).then((response) => {
                        this.setState({
                            isLoading: false,
                            email: "",
                            success: true
                        });
                    }, (error) => {
                        this.setState({isLoading: false});
                    });

                    //GOOGLE EVENT
                    if(this.platformLive()){
                        ReactGA.event({category: 'User', action: 'Subscribed Newsletter', label: 'Footer'});
                        ReactGA4.event({category: 'User', action: 'Subscribed Newsletter', label: 'Footer'});
                        //console.log("Fire event Newsletter");
                    }

                    //FACEBOOK EVENT
                    if(this.platformLive()){
                        ReactPixel.trackCustom('SubmitNewsletter');
                    }

                }else{
                    this.setState({error: true});
                }
            });
        }
    }

    go(option){
        try{
            this.props.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + option);
        }catch (error){}
    }

    login(){
        if(dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1){
            window.open("https://app.devadbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/login", '_blank');
        }else{
            window.open("https://app.adbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/login", '_blank');
        }
    }

    _terms(link){
        window.open('https://legal.'+dataRegister.domain+"/"+salesChannelRegister.get("market") + "/" + langRegister.lang() +"/"+ link + "/adbop", '_blank');
    }

    _help(){
        window.open('https://help.'+dataRegister.domain+"/"+salesChannelRegister.get("market") + "/" + langRegister.lang() +"/adbop", '_blank');
    }

    _emailValidation(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    _lisIndustries(){
        if(dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1){
            window.open("https://app.devadbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/signup/industry", '_blank');
        }else{
            window.open("https://app.adbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/signup/industry", '_blank');
        }
    }

    _renderLanguage(lang){
        let value = "";
        for(let i = 0; i < this.state.languages.length; i++){
            if(this.state.languages[i].code === lang){
                value = this.state.languages[i].names[langRegister.lang()];
            }
        }
        return value;
    }

    _renderMarket(market){
        let value = "";
        for(let i = 0; i < this.state.markets.length; i++){
            if(this.state.markets[i].code === market){
                value = this.state.markets[i].names[langRegister.lang()];
            }
        }
        return value;
    }

    _renderText(item) {
        //test
        return langRegister.get("footer", item);
    }

    platformLive() {
        try {
            return window.location.hostname.indexOf('dev') === -1;
        } catch (e) {
            return false
        }
    }

    render() {
        return (
            <div className={Styles.footer}>
                <img className={Styles.footerImageMobile} src={require("../../assets/images/AB_footer_mobile.png")}/>
                <div className={Styles.footerImage}/>
                <div className={Styles.footerInner}>
                    <div className={Styles.sectionOne}>
                        <div onClick={() => this.go("/")} className={Styles.sectionOneItemOne}>
                            {this._renderText("item_1")}
                        </div>
                        <div onClick={() => this._lisIndustries()} className={Styles.sectionOneItemOne}>
                            {this._renderText("item_2")}
                        </div>
                        <div onClick={() => this.go("/about")} className={Styles.sectionOneItemOne}>
                            {this._renderText("item_3")}
                        </div>
                        <a href={"mailto:support@adbop.com?Subject=" + this._renderText("item_23")} target="_top" className={Styles.sectionOneItemOneMiddle}>
                            {this._renderText("item_4")}
                        </a>
                        <div onClick={() => this.login()} className={Styles.sectionOneItemOne}>
                            {this._renderText("item_5")}
                        </div>
                        <div onClick={() => this.go("/vip")} className={Styles.sectionOneItemOneMiddle}>
                            {this._renderText("item_6")}
                        </div>
                        <div className={cx(Styles.dropdown, Styles.dropdownWhite)}>
                            <select className={Styles.dropdownSelection} value={this.state.lang} onChange={(event) => this._setLang(event.target.value)}>
                                {
                                    this.state.languages.map((item) => {
                                        return(
                                              <option value={item.code}>{item.names[langRegister.lang()]}</option>
                                        )
                                    })
                                }
                            </select>
                            <div className={cx(Styles.dropdownText, Styles.dropdownTextWhite)}>
                                {this._renderLanguage(this.state.lang)}
                            </div>
                            <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow_white.png")}/>
                        </div>
                    </div>
                    <div className={Styles.sectionTwo}>
                        <div className={Styles.sectionTwoItemOneHeader}>
                            {this._renderText("item_9")}
                        </div>
                        {
                            this.state.markets.map((item) => {
                                return(
                                    <div onClick={() => this._setMarket(item.code)} className={Styles.sectionTwoItemOne}>
                                        {item.names[langRegister.lang()]}
                                    </div>
                                )
                            })
                        }
                        <div className={cx(Styles.dropdown, Styles.dropdownGrey)}>
                            <select className={Styles.dropdownSelection} value={this.state.market} onChange={(event) => this._setMarket(event.target.value)}>
                                {
                                    this.state.markets.map((item) => {
                                        return(
                                              <option value={item.code}>{item.names[langRegister.lang()]}</option>
                                        )
                                    })
                                }
                            </select>
                            <div className={cx(Styles.dropdownText, Styles.dropdownTextGrey)}>
                                {this._renderMarket(this.state.market)}
                            </div>
                            <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow_grey_2.png")}/>
                        </div>
                    </div>
                    <div className={Styles.sectionThree}>
                        <div className={Styles.sectionThreeItemOneHeader}>
                            {this._renderText("item_11")}
                        </div>
                        {
                            this.state.trending.map((item) => {
                                return(
                                    <div onClick={() => this._selectIndustry(item)} className={Styles.sectionThreeItemOne}>
                                        {item.name}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className={Styles.footerBottom}>
                    <div className={Styles.socialIcons}>
                            <a className={Styles.socialIcon} href={"https://business.facebook.com/adBop-342034956357879/?business_id=418075078355273"} target={"_blank"}>
                                <img className={Styles.socialIconFb}
                                     src={require("../../assets/images/facebook_icon.png")}/>
                            </a>
                            <a className={Styles.socialIcon} href={"https://instagram.com/adbop"} target={"_blank"}>
                                <img className={Styles.socialIconInstagram}
                                     src={require("../../assets/images/instagram_icon.png")}/>
                            </a>
                        {
                            false &&
                            <div className={Styles.socialIcon}>
                                <img className={Styles.socialIconLinkedIn}
                                     src={require("../../assets/images/linkedin_icon.png")}/>
                            </div>
                        }
                        {
                            false &&
                            <div className={Styles.socialIcon}>
                                <img className={Styles.socialIconTwitter}
                                     src={require("../../assets/images/twitter_icon.png")}/>
                            </div>
                        }
                    </div>
                    <div className={Styles.inputContainer}>
                        <input onFocus={() => this.setState({success: false})} disabled={this.state.isLoading} value={this.state.email} onChange={(event) => this.setState({email: event.target.value.toLowerCase(), error: false})} placeholder={this._renderText("item_17")} className={Styles.inputContainerInput}/>
                        <div onClick={() => this._newsletter()} className={Styles.inputContainerButton}>
                            {
                                !this.state.isLoading && this.state.success && !this.state.error &&
                                this._renderText("item_24")
                            }
                            {
                                !this.state.isLoading && !this.state.success && !this.state.error &&
                                this._renderText("item_18")
                            }
                            {
                                !this.state.isLoading && this.state.error &&
                                <span className={Styles.inputContainerButtonError}>{this._renderText("item_25")}</span>
                            }
                            {
                                this.state.isLoading &&
                                <BeatLoader size={15} color={'#ffffff'} loading={true}/>
                            }
                        </div>
                    </div>
                </div>
                <div className={Styles.bottomText}>
                    <span onClick={() => this._terms("terms")}>{this._renderText("item_19")}</span> | <span onClick={() => this._terms("privacy")}>{this._renderText("item_20")}</span> | <span onClick={() => this._terms("acceptance")}>{this._renderText("item_21")}</span> | <span>©&nbsp;{this.state.year}&nbsp;{this._renderText("item_22")}</span>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/component.js